



















import { Vue, Prop, Component } from "vue-property-decorator";
import AButton from "./AButton.vue";
import { MONTH_NAMES, trunc } from "./Utils";

@Component({
    components: {
        AButton,
    },
})
export default class MonthPicker extends Vue {
    @Prop() value!: number;
    @Prop() readonly rangeMin!: Date | null;
    @Prop() readonly rangeMax!: Date | null;
    @Prop() availableDates!: Date[] | null;
    @Prop() refYear!: number;
    @Prop({ type: Boolean}) hideNotAvailableDates!: boolean;

    private get monthNames(): string[] {
        return MONTH_NAMES;
    }

    private get months(){
        if(this.hideNotAvailableDates){
            return this.monthNames.map((m,i) => ({name: m, number: i})).filter((m) => this.isMonthSelectable(m.number))
        }
        return this.monthNames.map((m,i) => ({name: m, number: i}))
    }

    private isMonthSelectable(m: number) {
        let available = true;
        if (this.availableDates) {
            available = this.availableDates.some(
                (date) => {return m === date.getMonth() && this.refYear === date.getFullYear()}
            );
        }
        return this.isInsideRange(m) && available;
    }

    private isInsideRange(m: number): boolean {        
        if (!this.rangeMin && !this.rangeMax) {
            return true;
        } else {
            const lastDateOfMonth = new Date(this.refYear, m + 1, 0).getDate();
            const firstDateOfMonth = new Date(this.refYear, m, 1).getDate();
            if (this.rangeMin && this.rangeMax) {
                const monthMin = this.rangeMin.getMonth();
                const monthMax = this.rangeMax.getMonth();
                const yearMax = this.rangeMax.getFullYear();
                const yearMin = this.rangeMin.getFullYear(); 
                const dayMin = this.rangeMin.getDate();
                const dayMax = this.rangeMax.getDate();
                if (
                    (this.refYear < yearMax && this.refYear > yearMin) ||
                    (this.refYear === yearMin && m > monthMin) ||
                    (this.refYear === yearMax && m < monthMax) || 
                    (this.refYear === yearMin && m === monthMin && dayMin < lastDateOfMonth) ||
                    (this.refYear === yearMax && m === monthMax && dayMax > firstDateOfMonth)
                ) {
                    return true;
                } else {
                    return false;
                }
            } else {
                if (this.rangeMin) {
                    const yearMin = this.rangeMin.getFullYear();
                    const monthMin = this.rangeMin.getMonth();
                    const dayMin = this.rangeMin.getDate();
                    if (this.refYear > yearMin || (this.refYear === yearMin && m > monthMin) || this.refYear === yearMin && m === monthMin && dayMin < lastDateOfMonth) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (this.rangeMax) {
                    const yearMax = this.rangeMax.getFullYear();
                    const monthMax = this.rangeMax.getMonth();
                    const dayMax = this.rangeMax.getDate();
                    if (this.refYear < yearMax || (this.refYear === yearMax && m < monthMax || this.refYear === yearMax && m === monthMax && dayMax > firstDateOfMonth)) {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        }
        return false;
    }
}
